import { Container, Input, Title, Main, Form, Button } from '../../components'
import styles from './styles.module.css'
import { useFormWithValidation } from '../../components/utils'
import { AuthContext } from '../../contexts'
import { Navigate } from 'react-router-dom'
import { useContext } from 'react'

const SignIn = ({ onSignIn }) => {
    const { values, handleChange, errors, isValid, resetForm } = useFormWithValidation()
    const authContext = useContext(AuthContext)
    console.log(authContext)
    return <Main>
        {authContext && <Navigate to='/userList/' />}
        <Container>
            <Title title='Авторизация' />
            <Form
                className={styles.form}
                onSubmit={e => {
                    e.preventDefault()
                    onSignIn(values)
                }}
            >
                <Input
                    required
                    label='Логин'
                    name='username'
                    onChange={handleChange}
                />
                <Input
                    required
                    label='Пароль'
                    type='password'
                    name='password'
                    onChange={handleChange}
                />
                <Button
                    modifier='style_dark-blue'
                    disabled={!isValid}
                    type='submit'
                    className={styles.button}
                >
                    Войти
                </Button>
            </Form>
        </Container>
    </Main>
}

export default SignIn
